import { render, staticRenderFns } from "./performanceIndicatorDetails.vue?vue&type=template&id=502d3688&scoped=true"
import script from "./performanceIndicatorDetails.vue?vue&type=script&lang=js"
export * from "./performanceIndicatorDetails.vue?vue&type=script&lang=js"
import style0 from "./performanceIndicatorDetails.vue?vue&type=style&index=0&id=502d3688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d3688",
  null
  
)

export default component.exports